var map = {
	"./obuchenie.svg": "2692",
	"./odezhda.svg": "ff2c",
	"./putevki.svg": "f93e",
	"./sportivnye-sertifikaty.svg": "abc9",
	"./super-priz.svg": "f34f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0323";